/* pl-pdp.js v2.0 (2026-09-23) — PL product page helpers for Stiletto 5.2.2
   v2.0: blueprint v1 — quantity presets next to the theme stepper, Judge.me re-layout (limit + show all, names / medals hidden,
         zero-review one-liner), mobile folds for FAQ. Sections / blocks are Liquid; this file only adds behaviour.
   v1.1: contact linkify — plain-text e-mail addresses / phone numbers anywhere on the product page (buy box, accordions,
         A+ blocks, footer) become mailto: / tel: links (DOM only; template / description HTML untouched). Setting "PL · Contact links".
   · desktop (thumbnails layout): prev/next arrows + "n / N" counter + drag/swipe + arrow keys on the main image
     (switches by clicking the theme's own thumbnail, so variant sync, lightbox and 3D/video handling stay the theme's)
   · mobile (swiper carousel): counter + arrows on top of the theme's carousel
   · description: hides <img> that repeat a gallery image (DOM only — product HTML untouched)
   Settings come from data-pl-gal-* on the product section root (see main-product--default.liquid schema "PL · Gallery"). */
(function () {
  'use strict';
  if (window.__plPdp) return; window.__plPdp = '2.0';
  var q = function (s, r) { return (r || document).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ICON_PREV = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function keyOf(u) {
    if (!u) return '';
    try { u = decodeURIComponent(u); } catch (e) { }
    u = String(u).split('?')[0].split('#')[0];
    var yt = u.match(/\/vi\/([^\/]+)\//); if (yt) return 'yt:' + yt[1];
    var f = u.split('/').pop().toLowerCase();
    f = f.replace(/\.(progressive\.)?(jpe?g|png|webp|gif|avif)$/, '');
    f = f.replace(/_(\d+x\d*|\d*x\d+)(@\dx)?(_crop_[a-z]+)?$/, '');
    f = f.replace(/_[0-9a-f]{32}$/, '');
    return f;
  }
  function srcOf(img) {
    var a = img.closest && img.closest('a[data-pswp-src]');
    if (a) return a.getAttribute('data-pswp-src');
    var s = img.getAttribute('src') || img.getAttribute('data-src') || '';
    if (!s || /^data:/.test(s)) { var ss = img.getAttribute('srcset') || img.getAttribute('data-srcset') || ''; s = ss.split(',')[0].trim().split(/\s+/)[0] || s; }
    return s;
  }
  function pill(cls, html, label) {
    var b = document.createElement(label ? 'button' : 'span');
    b.className = cls; b.innerHTML = html;
    if (label) { b.type = 'button'; b.setAttribute('aria-label', label); }
    return b;
  }
  function isTyping() { var a = document.activeElement; return a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName); }
  function lightboxOpen() { return !!q('.pswp--open, .pswp.pswp--ui-visible'); }
  function inView(el) { var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; }

  /* ---------- desktop: thumbnails layout ---------- */
  function desktop(root, cfg) {
    var box = q('.product__media-container.above-mobile', root); if (!box) return;
    if (box.getAttribute('data-gallery-style') !== 'thumbnails') return;
    if (box.classList.contains('pl-gal')) return;
    var media = q('.product__media', box); if (!media) return;
    var items = qa(':scope > .product__media-item', media); if (items.length < 2) return;
    var thumbs = qa('[data-product-thumbnail]', box);
    var thumbById = {}; thumbs.forEach(function (t) { thumbById[t.getAttribute('data-thumbnail-id')] = t; });
    var vp = q('.product-thumbnails__viewport', box);
    box.classList.add('pl-gal');
    var n = items.length, prev, next, counter;
    function cur() { for (var i = 0; i < n; i++) if (!items[i].classList.contains('hidden')) return i; return 0; }
    function scrollThumb(t) {
      if (!t || !vp) return; var li = t.closest('li') || t;
      var top = li.offsetTop - vp.offsetTop, h = li.offsetHeight, st = vp.scrollTop, ch = vp.clientHeight;
      if (top < st + 8) vp.scrollTo({ top: Math.max(0, top - 8), behavior: 'smooth' });
      else if (top + h > st + ch - 8) vp.scrollTo({ top: top + h - ch + 8, behavior: 'smooth' });
    }
    function paint() {
      var i = cur();
      if (counter) counter.textContent = (i + 1) + ' / ' + n;
      var id = items[i].getAttribute('data-media-item-id'); scrollThumb(thumbById[id]);
    }
    function go(d) {
      var i = (cur() + d + n) % n, id = items[i].getAttribute('data-media-item-id'), t = thumbById[id];
      if (t) { t.click(); } else { items.forEach(function (it, k) { it.classList.toggle('hidden', k !== i); }); }
      paint();
    }
    if (cfg.arrows) {
      prev = pill('pl-gal__btn pl-gal__btn--prev', ICON_PREV, 'Previous image');
      next = pill('pl-gal__btn pl-gal__btn--next', ICON_NEXT, 'Next image');
      prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); });
      next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); });
      media.appendChild(prev); media.appendChild(next);
    }
    if (cfg.counter) { counter = pill('pl-gal__count', ''); media.appendChild(counter); }
    if (cfg.swipe) {
      var x0 = null, y0 = null, dragged = false, pid = null;
      media.classList.add('pl-gal__swipe');
      media.addEventListener('pointerdown', function (e) { if (e.button !== 0 && e.pointerType === 'mouse') return; if (e.target.closest('.pl-gal__btn, button, model-viewer, video, iframe')) return; x0 = e.clientX; y0 = e.clientY; pid = e.pointerId; dragged = false; });
      media.addEventListener('pointermove', function (e) { if (x0 === null || e.pointerId !== pid) return; if (Math.abs(e.clientX - x0) > 12 && Math.abs(e.clientX - x0) > Math.abs(e.clientY - y0)) dragged = true; });
      function end(e) {
        if (x0 === null || e.pointerId !== pid) return;
        var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { dragged = true; go(dx < 0 ? 1 : -1); setTimeout(function () { dragged = false; }, 350); }
        else dragged = false;
      }
      media.addEventListener('pointerup', end); media.addEventListener('pointercancel', function () { x0 = null; });
      media.addEventListener('click', function (e) { if (dragged) { e.preventDefault(); e.stopPropagation(); } }, true);
      media.addEventListener('dragstart', function (e) { if (e.target.tagName === 'IMG' || e.target.tagName === 'A') e.preventDefault(); });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        if (isTyping() || lightboxOpen() || !inView(box) || box.offsetParent === null) return;
        go(e.key === 'ArrowRight' ? 1 : -1); e.preventDefault();
      });
    }
    var mo = new MutationObserver(function () { paint(); });
    items.forEach(function (it) { mo.observe(it, { attributes: true, attributeFilter: ['class'] }); });
    paint();
  }

  /* ---------- mobile: swiper carousel ---------- */
  function mobile(root, cfg) {
    var box = q('.product__media-container.below-mobile.carousel', root); if (!box) return;
    var slides = qa('.swiper-slide:not(.swiper-slide-duplicate)', box); if (slides.length < 2) return;
    if (box.classList.contains('pl-gal')) return;
    var tries = 0;
    (function wait() {
      var sw = box.swiper;
      if (!sw) { if (tries++ < 60) return setTimeout(wait, 150); return; }
      box.classList.add('pl-gal');
      var n = slides.length, counter;
      function idx() { return typeof sw.realIndex === 'number' ? sw.realIndex : sw.activeIndex; }
      function paint() { if (counter) counter.textContent = ((idx() % n) + 1) + ' / ' + n; }
      if (cfg.arrowsMobile) {
        var prev = pill('pl-gal__btn pl-gal__btn--prev', ICON_PREV, 'Previous image');
        var next = pill('pl-gal__btn pl-gal__btn--next', ICON_NEXT, 'Next image');
        prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (sw.params.loop || idx() > 0) sw.slidePrev(); else sw.slideTo(n - 1); });
        next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (sw.params.loop || idx() < n - 1) sw.slideNext(); else sw.slideTo(0); });
        box.appendChild(prev); box.appendChild(next);
      }
      if (cfg.counter) { counter = pill('pl-gal__count', ''); box.appendChild(counter); }
      sw.on('slideChange', paint); sw.on('slideChangeTransitionEnd', paint); paint();
    })();
  }

  /* ---------- description de-duplication ---------- */
  function dedupe(root, cfg) {
    var keys = {};
    qa('.product__media-container.above-mobile .product__media-item, .product__media-container.below-mobile .product__media-item', root).forEach(function (it) {
      qa('a[data-pswp-src], img', it).forEach(function (el) { var k = keyOf(el.getAttribute('data-pswp-src') || srcOf(el)); if (k && k.indexOf('yt:') !== 0) keys[k] = 1; });
    });
    if (!Object.keys(keys).length) return 0;
    var skip = (cfg.dedupeSkip || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var hidden = 0, boxes = [];
    qa('.product__block .rte, .product__block--description, .accordion__content.rte', root).forEach(function (desc) {
      if (qa('.product__media-container', desc).length) return;
      qa('img', desc).forEach(function (img) {
        if (img.closest('.pl-gal-dup')) return;
        var k = keyOf(srcOf(img)); if (!k || !keys[k]) return;
        if (skip.length) { var chain = ''; for (var p = img.parentElement; p && p !== desc; p = p.parentElement) chain += ' ' + (p.className || '') + ' ' + (p.id || ''); chain = chain.toLowerCase(); if (skip.some(function (s) { return chain.indexOf(s) >= 0; })) return; }
        var wrap = img, p2 = img.parentElement;
        while (p2 && p2 !== desc && (p2.textContent || '').trim().length === 0 && qa('img, iframe, video', p2).length === 1) { wrap = p2; p2 = p2.parentElement; }
        wrap.classList.add('pl-gal-dup'); wrap.setAttribute('data-pl-dup', k); hidden++;
        if (p2 && p2 !== desc && boxes.indexOf(p2) < 0) boxes.push(p2);
      });
    });
    boxes.forEach(function (b) {
      var kids = qa(':scope > *', b), vis = kids.filter(function (k) { return !k.classList.contains('pl-gal-dup') && (k.textContent || '').trim().length + qa('img, iframe, video', k).length > 0; });
      if (kids.length && !vis.length && (b.textContent || '').trim().length === 0) b.classList.add('pl-gal-dup');
    });
    return hidden;
  }


  /* ---- v1.1 contact linkify ---------------------------------------------------------------- */
  var EMAIL_RE = /[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}/g;
  // phone: "+1 800-901-9318", "(800) 901-9318", "800.901.9318", "+44 20 7946 0958" — needs a leading + or a 3-3-4 grouping, 10–15 digits
  var PHONE_RE = /(?:\+\d{1,3}[\s.-]?)?(?:\(\d{2,4}\)|\d{2,4})[\s.-]\d{3,4}[\s.-]\d{3,4}(?:[\s.-]\d{2,4})?|\+\d[\d\s.()-]{8,}\d/g;
  var SKIP_TAGS = /^(A|SCRIPT|STYLE|NOSCRIPT|TEMPLATE|TEXTAREA|INPUT|SELECT|OPTION|BUTTON|CODE|PRE|SVG|IFRAME)$/;
  function telHref(t) {
    var plus = t.trim().charAt(0) === '+', d = t.replace(/\D/g, '');
    if (d.length < 10 || d.length > 15) return '';
    if (!plus && d.length === 10) d = '1' + d;
    return 'tel:+' + d;
  }
  function phoneOk(m) {
    var d = m.replace(/\D/g, ''); if (d.length < 10 || d.length > 15) return false;
    if (m.trim().charAt(0) === '+') return true;
    return /(?:\(\d{3}\)|\d{3})[\s.-]\d{3}[\s.-]\d{4}/.test(m);
  }
  function linkifyNode(tn, made) {
    var text = tn.nodeValue; if (!text || text.length < 8 || (text.indexOf('@') < 0 && !/\d[\d\s().-]{8,}\d/.test(text))) return;
    var hits = [], m;
    EMAIL_RE.lastIndex = 0; while ((m = EMAIL_RE.exec(text))) hits.push({ i: m.index, t: m[0], href: 'mailto:' + m[0], k: 'email' });
    PHONE_RE.lastIndex = 0; while ((m = PHONE_RE.exec(text))) { var s = m[0].replace(/[\s.-]+$/, ''); if (!phoneOk(s)) continue; var h = telHref(s); if (!h) continue; var i = m.index, e = i + s.length, clash = hits.some(function (x) { return i < x.i + x.t.length && e > x.i; }); if (!clash) hits.push({ i: i, t: s, href: h, k: 'phone' }); }
    if (!hits.length) return;
    hits.sort(function (a, b) { return a.i - b.i; });
    var frag = document.createDocumentFragment(), pos = 0;
    hits.forEach(function (h) {
      if (h.i > pos) frag.appendChild(document.createTextNode(text.slice(pos, h.i)));
      var a = document.createElement('a'); a.href = h.href; a.textContent = h.t; a.className = 'pl-contact pl-contact--' + h.k; a.setAttribute('data-pl-contact', h.k);
      frag.appendChild(a); pos = h.i + h.t.length; made.push(h.href);
    });
    if (pos < text.length) frag.appendChild(document.createTextNode(text.slice(pos)));
    tn.parentNode.replaceChild(frag, tn);
  }
  function linkifyContacts(scopeSel) {
    var scopes = scopeSel ? qa(scopeSel) : [document.body]; if (!scopes.length) scopes = [document.body];
    var made = [];
    scopes.forEach(function (scope) {
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          var p = n.parentElement; if (!p) return NodeFilter.FILTER_REJECT;
          if (n.nodeValue.indexOf('@') < 0 && !/\d[\d\s().-]{8,}\d/.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
          for (var e = p; e && e !== scope.parentElement; e = e.parentElement) {
            if (SKIP_TAGS.test(e.tagName) || e.isContentEditable || e.getAttribute('data-pl-nolink') !== null) return NodeFilter.FILTER_REJECT;
            var c = e.className; if (typeof c === 'string' && /(^|\s)(jdgm-|kl-|klaviyo|pswp|wl-kit|product__sku|sku)/.test(c)) return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var nodes = [], n; while ((n = walker.nextNode())) nodes.push(n);
      nodes.forEach(function (tn) { try { linkifyNode(tn, made); } catch (e) { } });
    });
    return made;
  }

  /* ---- v2.0 quantity presets ---------------------------------------------------------------- */
  function qtyPresets(root) {
    var box = q('[data-pl-qhint]', root); if (!box || box.__pl) return; box.__pl = 1;
    var qblock = q('.product__controls-group-quantity', root), input = qblock && q('[data-quantity-input]', qblock);
    if (qblock && input) { var item = q('.product__item', qblock) || qblock; box.classList.add('pl-qhint--inline'); item.appendChild(box); }
    var bs = qa('[data-pl-qty]', box);
    function paint() { var v = input ? parseInt(input.value, 10) : 1; bs.forEach(function (b) { b.classList.toggle('is-on', parseInt(b.getAttribute('data-pl-qty'), 10) === v); }); }
    bs.forEach(function (b) { b.addEventListener('click', function () { if (!input) return; input.value = b.getAttribute('data-pl-qty'); input.dispatchEvent(new Event('change', { bubbles: true })); paint(); }); });
    if (input) { input.addEventListener('change', paint); input.addEventListener('input', paint); }
    paint();
  }

  /* ---- v2.0 mobile folds (FAQ list) --------------------------------------------------------- */
  function folds() {
    qa('[data-pl-fold="true"]').forEach(function (el) {
      if (el.__pl) return; el.__pl = 1;
      if (el.children.length <= 3) return;
      el.classList.add('pl-folded');
      var b = document.createElement('button'); b.type = 'button'; b.className = 'pl-fold__btn'; b.textContent = el.getAttribute('data-pl-fold-text') || 'Show all';
      b.addEventListener('click', function () { el.classList.remove('pl-folded'); b.remove(); });
      el.parentNode.insertBefore(b, el.nextSibling);
    });
  }

  /* ---- v2.0 Judge.me re-layout (widget DOM only; app settings untouched) -------------------- */
  function reviews() {
    var head = q('[data-pl-reviews]'); if (!head || head.__pl) return; head.__pl = 1;
    var d = head.dataset, cfg = { limit: parseInt(d.plRvLimit, 10) || 3, limitM: parseInt(d.plRvLimitM, 10) || 2, names: d.plRvNames !== 'false', medals: d.plRvMedals === 'true', all: d.plRvAll || 'Show all [n] reviews', less: d.plRvLess || 'Show fewer', count: parseInt(d.plRvCount, 10) || 0 };
    var write = q('[data-pl-write]', head);
    if (write) write.addEventListener('click', function (e) { e.preventDefault(); var l = q('.jdgm-write-rev-link'); var wr = l && (l.closest('.shopify-section') || l.parentElement); if (wr) wr.classList.remove('pl-jdgm--empty'); if (l) l.click(); });
    var tries = 0;
    (function wait() {
      var w = q('.jdgm-rev-widg'); if (!w) { if (tries++ < 80) return setTimeout(wait, 250); return; }
      var wrap = w.closest('.shopify-section') || w.parentElement; wrap.classList.add('pl-jdgm');
      wrap.classList.toggle('pl-jdgm--page', head.classList.contains('pl-sec--page'));
      wrap.classList.toggle('pl-jdgm--nonames', cfg.names); wrap.classList.toggle('pl-jdgm--nomedals', !cfg.medals);
      var n = parseInt(w.getAttribute('data-number-of-reviews'), 10); if (isNaN(n)) n = cfg.count;
      if (n === 0) { wrap.classList.add('pl-jdgm--empty'); return; }
      var lim = window.matchMedia('(max-width:640px)').matches ? cfg.limitM : cfg.limit, showAll = false, foot;
      function apply() {
        var hdr = q('.jdgm-rev-widg__header', w), stars = hdr && q('.jdgm-rev-widg__summary-stars', hdr);
        if (stars && !q('.pl-jdgm__avg', hdr)) { var avg = document.createElement('span'); avg.className = 'pl-jdgm__avg'; avg.textContent = w.getAttribute('data-average-rating') || ''; stars.parentNode.insertBefore(avg, stars); }
        var revs = qa('.jdgm-rev-widg__reviews .jdgm-rev', w); if (!revs.length) return;
        revs.forEach(function (r, i) { r.classList.toggle('pl-hide', !showAll && i >= lim); });
        var need = !showAll && (revs.length > lim || n > revs.length) || showAll;
        if (!foot) { foot = document.createElement('div'); foot.className = 'pl-jdgm__foot'; var b = document.createElement('button'); b.type = 'button'; b.className = 'pl-btn pl-btn--ghost'; foot.appendChild(b); b.addEventListener('click', function () { showAll = !showAll; wrap.classList.toggle('pl-jdgm--all', showAll); apply(); if (!showAll) w.scrollIntoView({ block: 'start', behavior: 'smooth' }); }); }
        var btn = q('button', foot); btn.textContent = showAll ? cfg.less : cfg.all.replace('[n]', String(n));
        var list = q('.jdgm-rev-widg__reviews', w); if (list && foot.parentNode !== list.parentNode) list.parentNode.insertBefore(foot, list.nextSibling);
        foot.style.display = need ? '' : 'none';
      }
      apply();
      var mo = new MutationObserver(function () { clearTimeout(mo.t); mo.t = setTimeout(apply, 60); }); mo.observe(w, { childList: true, subtree: true });
    })();
  }

  /* ---- r2: sticky ATC bar only after the buy button has scrolled ABOVE the viewport (theme also shows it below the fold) */
  function stickyGate(root) {
    var bar = q('.sticky-atc-bar', root) || q('.sticky-atc-bar'); var btn = q('[data-add-to-cart]', root); if (!bar || !btn || bar.__pl) return; bar.__pl = 1;
    function tick() { var r = btn.getBoundingClientRect(); bar.classList.toggle('pl-wait', r.bottom > 0); }
    window.addEventListener('scroll', tick, { passive: true }); window.addEventListener('resize', tick); tick(); setTimeout(tick, 800);
  }
  /* ---- r2: mobile folds for contact card / second shipping card */
  function mfolds() {
    var mob = window.matchMedia('(max-width:640px)').matches;
    qa('.pl-ccard, .pl-ship__grid .pl-scard:nth-child(2)').forEach(function (el) {
      if (el.__pl) return; el.__pl = 1; if (!mob) return;
      el.classList.add('is-folded'); var b = document.createElement('button'); b.type = 'button'; b.className = 'pl-mfold__btn'; b.textContent = el.getAttribute('data-pl-more') || 'Show more';
      b.addEventListener('click', function () { var f = el.classList.toggle('is-folded'); b.textContent = f ? (el.getAttribute('data-pl-more') || 'Show more') : (el.getAttribute('data-pl-less') || 'Show less'); });
      el.appendChild(b);
    });
  }
  function init() {
    var root = q('[data-section-type="product"][data-is-full-product="true"]'); if (!root) return;
    var d = root.dataset, on = function (v, def) { return v === undefined ? def : v === 'true'; };
    var cfg = { arrows: on(d.plGalArrows, true), arrowsMobile: on(d.plGalArrowsMobile, true), counter: on(d.plGalCounter, true), swipe: on(d.plGalSwipe, true), dedupe: on(d.plGalDedupe, true), dedupeSkip: d.plGalDedupeSkip === undefined ? 'dimension,size,spec,drawing' : d.plGalDedupeSkip, contact: on(d.plContactLinks, true), contactScope: d.plContactScope === undefined ? '' : d.plContactScope };
    try { desktop(root, cfg); } catch (e) { console.warn('pl-pdp desktop', e); }
    try { mobile(root, cfg); } catch (e) { console.warn('pl-pdp mobile', e); }
    if (cfg.dedupe) { try { window.__plPdpDedupe = dedupe(root, cfg); } catch (e) { console.warn('pl-pdp dedupe', e); } }
    if (cfg.contact) {
      var runLink = function () { try { window.__plPdpContacts = (window.__plPdpContacts || []).concat(linkifyContacts(cfg.contactScope)); } catch (e) { console.warn('pl-pdp contact', e); } };
      runLink(); setTimeout(runLink, 1500); setTimeout(runLink, 4000); // late-rendered sections (apps / lazy blocks)
    }
    try { qtyPresets(root); } catch (e) { console.warn('pl-pdp qty', e); }
    try { stickyGate(root); } catch (e) { console.warn('pl-pdp sticky', e); }
    try { mfolds(); } catch (e) { console.warn('pl-pdp mfolds', e); }
    try { folds(); } catch (e) { console.warn('pl-pdp folds', e); }
    try { reviews(); } catch (e) { console.warn('pl-pdp reviews', e); }
    window.__plPdpReady = true;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { window.__plPdpReady = false; setTimeout(init, 50); });
})();
